import React, { useState, useEffect } from "react";

const OTPTimer = ({ expirationTime, setNeedResend }) => {
  const [remainingTime, setRemainingTime] = useState(expirationTime);

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (remainingTime === 0) {
      setNeedResend(true);
    }
  }, [remainingTime]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secondsLeft = seconds % 60;
    return `${minutes}:${secondsLeft < 10 ? "0" : ""}${secondsLeft}`;
  };

  return (
    <div
      style={{
        color: "#081f6f",
        fontWeight: "bold",
      }}
    >
      {formatTime(remainingTime)}
    </div>
  );
};

export default OTPTimer;
